import { IOpenMarketProductCommon } from '../../interfaces/Product.interfaces';

// TODO: 중복 함수 공통 유틸로 정의할 필요가 있는지 확인
export const getOpenMarketProductTitle = (product: IOpenMarketProductCommon) => {
  return `${product.machine.brand.name} ${product.machine.model} 트랙터`;
};
